import PEOPLE from './assets/people.svg';
import { useActions } from 'app/hooks/useActions';
import { Icon, TextLink } from '@kontentino/ui';
import UserPermissionGate from 'components/UserPermissionGate';
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import { useTranslation } from 'react-i18next';

export const PostsCommunicationEmptyMessage = () => {
  const { userActions } = useActions('users');
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-py-6 tw-text-center">
      <img src={PEOPLE} alt="People" />
      <p className="tw-text-sm">{t('comments.youDontHaveAnyCommentsYet')}</p>
      <UserPermissionGate scopes={userActions.inviteUser.scopes}>
        <TextLink>
          <span
            className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-text-sm"
            onClick={() => userActions.inviteUser.perform?.()}
            data-name="post-communication_invite-user_button"
            data-cy="post-communication_invite-user_button"
          >
            <Icon icon={faUserPlus} size="sm" />
            {t('comments.inviteATeamMemberOrClient')}
          </span>
        </TextLink>
      </UserPermissionGate>
    </div>
  );
};
